import Choices from "choices.js"
import debounce from "debounce"
import { Controller } from "@hotwired/stimulus"
import { destroyChoices } from "../utils/choices_destroy"

export default class extends Controller {
  static targets = ['field']
  static values = { paramName: String }

  connect() {
    this.instance = new Choices(this.fieldTarget, {
      duplicateItemsAllowed: false,
      classNames: this.classNames,
      placeholder: true,
      searchPlaceholderValue: (this.data.get('hint') || ''),
      noChoicesText: '',
      allowHTML: true
    })

    if (this.data.has('url')) {
      this.onSearch = debounce(this.search, 500)
      this.element.addEventListener('search', this.onSearch)
    }
  }

  disconnect() {
    if (this.onSearch) {
      this.element.removeEventListener('search', this.onSearch)
      this.onSearch.clear()
      this.onSearch = undefined
    }
    this.abortSearch()

    const choices = this.instance
    this.instance = undefined
    destroyChoices(choices)
  }

  abortSearch() {
    this.searchAbort?.abort()
    this.searchAbort = undefined
  }

  search = (evt) => {
    if (!this.instance) return

    this.abortSearch()

    if (!evt.detail?.value) {
      this.instance.clearChoices()
      return
    }

    const abort = new AbortController()
    this.searchAbort = abort
    const choices = this.instance

    fetch(this.searchUrl(evt.detail.value), { ...this.options, signal: abort.signal })
      .then((response) => response.json())
      .then((data) => {
        if (this.instance !== choices) return
        choices.setChoices(data, 'id', 'name', true)
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return
        throw error
      })
  }

  searchUrl(query) {
    let path = this.data.get('url').split('?')[0]
    let params = new URLSearchParams(this.data.get('url').split('?')[1])
    params.set(this.paramName, query)

    return path.concat('?').concat(params)
  }

  get paramName () {
    return this.paramNameValue || 'query'
  }

  get options() {
    return {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }
  }

  get classNames() {
    return {
      containerOuter: 'pillbox',
      containerInner: 'pillbox-inner',
      input: 'pillbox-input',
      inputCloned: 'pillbox-input--cloned',
      list: 'pillbox-list',
      listItems: 'pillbox-list--multiple',
      listSingle: 'pillbox-list--single',
      listDropdown: 'pillbox-list--dropdown',
      item: 'pillbox-item',
      itemSelectable: 'pillbox-item--selectable',
      itemDisabled: 'pillbox-item--disabled',
      itemChoice: 'pillbox-item--choice',
      placeholder: 'pillbox-placeholder',
      group: 'pillbox-group',
      groupHeading: 'pillbox-heading',
      button: 'pillbox-button',
      activeState: 'pillbox--active',
      focusState: 'pillbox--focused',
      openState: 'pillbox--open',
      disabledState: 'pillbox--disabled',
      highlightedState: 'pillbox--highlighted',
      hiddenState: 'pillbox--hidden',
      flippedState: 'pillbox--flipped',
      loadingState: 'pillbox--loading',
      noResults: 'pillbox--no_results',
      noChoices: 'pillbox--no_choices'
    }
  }
}
